// @flow
import { combineReducers } from 'redux';

import { getOrderListReducer } from '../../Orders/List/redux';
import { getOrderDetailsReducer } from '../../Orders/Details/redux';
import { getCustomerInfoReducer } from '../CustomerInfo/redux';
import { getFlashMessagesReducer } from '../flash-messages/redux';
import { getFooterReducer } from '../footer/redux';
import { getCartReducer } from '../cart/redux';
import { getOpenCampaignsReducer } from '../header/redux';
import { getOrderReturnsReducer } from '../../Orders/Returns/redux';

export const reducer = combineReducers({
    ...getOrderListReducer(),
    ...getOrderDetailsReducer(),
    ...getCustomerInfoReducer(),
    ...getFlashMessagesReducer(),
    ...getFooterReducer(),
    ...getCartReducer(),
    ...getOpenCampaignsReducer(),
    ...getOrderReturnsReducer(),
});
